import { Injectable } from '@angular/core';
import {
  ClaimsAdvancedFilterComponent,
} from '@th-common-retailer/shared/pages/claims/containers/claims-advanced-filter/claims-advanced-filter.component';
import {
  PlansAdvancedFilterComponent,
} from '@th-common-retailer/shared/pages/plans/containers/plans-advanced-filter/plans-advanced-filter.component';

import { RouterConstants } from '@core/constants/router.constants';
import { Feature } from '@core/enums/feature.enum';
import { NavigationService } from '@core/services/navigation.service';
import { NavigationInterface } from '@shared/modules/navigation/components/navigation/navigation.component';

@Injectable()
export class DealerNavigationService extends NavigationService {
  getNavList(): NavigationInterface[] {
    return [
      {
        route: '/app/dashboard',
        name: 'Dashboard',
        features: [Feature.ViewDashboard],
        child: [],
        icon: 'dashboard',
      },
      {
        route: '/app/claims',
        name: 'Claims',
        features: [Feature.ViewClaims],
        child: [],
        icon: 'claim-2',
        class: 'claim',
        filterComponent: ClaimsAdvancedFilterComponent,
      },
      {
        route: '/app/plans',
        name: 'Plans',
        features: [Feature.HasProtectionPlans],
        child: [],
        icon: 'plans',
        class: 'plans',
        filterComponent: PlansAdvancedFilterComponent,
      },
      {
        route: '/app/reports',
        name: 'Reports',
        features: [Feature.HasReports],
        child: [],
        icon: 'reports',
      },
      {
        route: '/app/admin',
        name: 'Admin',
        features: RouterConstants.features.admin,
        featureOptions: {
          some: true,
        },
        icon: 'admin',
        child: [
          {
            route: '/app/admin/users',
            name: 'Users',
            features: [Feature.ViewUsers],
          },
          {
            route: '/app/admin/regions',
            name: 'Regions',
            features: [Feature.ViewRegions],
          },
        ],
      },
      {
        route: '/app/contact-info',
        name: 'Contact Info',
        isAllow: true,
        child: [],
        icon: 'contact',
      },
      {
        route: '/app/help',
        name: 'Help',
        isAllow: true,
        icon: 'help',
        child: [],
      },
    ];
  }
}
